import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AccountContext } from '../../contexts/account.context';
import { Page } from '../../general/Page';
import { UserForm } from '../../general/UserForm';
import { useUser } from '../../../hooks/use-user';
import { NotFound } from '../../general/NotFound';
import { Spinner } from '../../general/Spinner';

type Props = {
  userId?: string;
};

export const UserFormPage = ({ userId }: Props) => {
  const history = useHistory();
  const { getUser } = useContext(AccountContext);
  const { loading, user } = useUser(userId);

  if (loading) {
    return <Spinner />;
  }

  if (userId && !user) {
    return <NotFound title="Utilisateur introuvable" />;
  }

  return (
    <Page>
      <UserForm clientId={user?.clientId || getUser().clientId} user={user} onSave={user => history.push(`/users/${user.id}`)}/>
    </Page>
  );
};
